import { render, staticRenderFns } from "./Event-Wrapper.vue?vue&type=template&id=68746b6d&scoped=true&"
import script from "./Event-Wrapper.vue?vue&type=script&lang=js&"
export * from "./Event-Wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68746b6d",
  null
  
)

export default component.exports